"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const oaf_routing_1 = require("oaf-routing");
exports.defaultSettings = Object.assign({}, oaf_routing_1.defaultSettings);
// HACK we need a way to track where focus and scroll were left on the first loaded page
// but we won't have an entry in history for this initial page, so we just make up a key.
const orInitialKey = (key) => key !== undefined ? key : "initial";
exports.wrapHistory = (history, settingsOverrides) => {
    const settings = Object.assign(Object.assign({}, exports.defaultSettings), settingsOverrides);
    const oafRouter = oaf_routing_1.createOafRouter(settings, location => location.hash);
    const initialLocation = history.location;
    // HACK Allow DOM to be updated before we repair focus.
    setTimeout(() => {
        // The first page load won't trigger history.listen.
        oafRouter.handleFirstPageLoad(initialLocation);
    }, settings.renderTimeout);
    // tslint:disable-next-line: no-let
    let previousLocation = initialLocation;
    const unlisten = history.listen(event => {
        oafRouter.handleLocationWillChange(orInitialKey(previousLocation.key), orInitialKey(event.location.key), event.action);
        // HACK Allow DOM to be updated before we repair focus.
        const stablePreviousLocation = previousLocation;
        setTimeout(() => {
            oafRouter.handleLocationChanged(stablePreviousLocation, event.location, orInitialKey(event.location.key), event.action);
        }, settings.renderTimeout);
        previousLocation = event.location;
    });
    return () => {
        oafRouter.resetAutoScrollRestoration();
        unlisten();
    };
};
